export default __webpack_public_path__ + "static/media/contentold2020.77860d5f.png";